export const getFileSize = (fSize) => {
    // console.log("fSize 2", fSize);
    var fSExt = new Array("Bytes", "KB", "MB", "GB", "TB");
    var i = 0;
    while (fSize > 900) {
        fSize /= 1000;
        if (i >= fSExt) {
            break;
        } else {
            i++;
        }
    }
    return fSize.toFixed(1) + " " + fSExt[i];
};
